<template>
  <el-container style="height: 100vh;">
    <el-aside style="width: 200px;">
      <Menu activeName="1-1"></Menu>
    </el-aside>
    <el-main style="display: flex;flex-direction: row;flex: 1;padding: 0;">
      <div
        style="width: 300px;background-color: #fff;margin-top: 20px;padding: 0 10px;display: flex;flex-direction: column;">
        <el-input size="small" placeholder="请输入内容" v-model="form.name" clearable @clear="clearSearch">
          <el-button slot="append" icon="el-icon-search" @click="searchPlace"></el-button>
        </el-input>
        <div class="infinite-list-wrapper" style="overflow:auto;margin-top: 10px;flex: 1;padding-bottom: 20px;">
          <div class="infinite-list" v-infinite-scroll="loadMore" :infinite-scroll-disabled="disabled">
            <el-card class="box-card infinite-list-item" :class="index === detailsIndex ? 'active-card' : ''"
              shadow="hover" v-for="(place, index) in placeList" v-bind:key="index" style="padding-bottom: 1px;">
              <div style="display: flex;flex-direction: column;" @click="showPlaceDetails(index)">
                <span style="font-size: 16px;font-weight: bold;color: #333;">{{ place.name }}</span>
                <p style="font-size: 14px;color: #666;margin-top: 2px;margin-bottom: 0;">{{ place.address }}</p>
                <div class="phone">
                  <span v-if="place.phone_name">{{ place.phone_name }}</span>
                  <span v-if="place.phone">({{ place.phone }})</span>
                </div>
                <p style="font-size: 12px;color: #909399;margin-bottom: 0;" v-if="place.remarks">{{ place.remarks }}</p>
              </div>
            </el-card>
          </div>

          <el-empty v-if="empty" description="暂无地点"></el-empty>
          <el-divider v-if="loading">加载中...</el-divider>
          <el-divider v-if="noMore">没有更多了</el-divider>
        </div>
      </div>
      <el-amap ref="map" vid="map" @init="initMap" style="flex: 1;" :center="mapConf.center">
        <el-amap-control-geolocation :visible="true"></el-amap-control-geolocation>
        <el-amap-control-map-type :visible="true"></el-amap-control-map-type>

        <template v-if="placeMarkers.length > 0">
          <el-amap-layer-labels :collision="false" @init="initLabelsLayer">
            <el-amap-label-marker v-for="(item, index) in placeMarkers" :key="'place-' + index"
              :position="[item.locations.longitude, item.locations.latitude]" :icon="markerStyle.icon" :rank="0"
              :text="{ content: item.name, style: markerStyle.text }" @click="showPlaceDetailsMap(item)"
              @mouseover="handleMouseOver(item)" @mouseout="handleMouseLeave"></el-amap-label-marker>
          </el-amap-layer-labels>
        </template>
        <template v-if="placeMarkers.length > 0">
          <el-amap-info-window v-for="(item, index) in placeMarkers" :key="'place-window-' + index"
            :closeWhenClickMap="true" :position="[item.locations.longitude, item.locations.latitude]" :autoMove="false"
            :offset="[0, -20]" anchor="bottom-center" :visible="item.id == mapConf.overPlaceId">
            <div style="display: flex;flex-direction: column;padding:4px;margin-top: 4px;">
              <div style="font-size: 16px;color: #333;font-weight: 500">{{ item.name }}</div>
              <div style="font-size: 14px;color: #333;margin-top: 4px;">{{ item.address }}</div>
              <div style="font-size: 14px;color: #333;margin-top: 8px;">客户：{{ item.phone_name }}</div>
              <div style="font-size: 14px;color: #333;">电话：{{ item.phone }}</div>
            </div>
          </el-amap-info-window>
        </template>

      </el-amap>
      <div style="position:fixed;top: 20px;left: 540px;z-index: 1;">
        <div style="background-color: #fff;width: 300px;" v-if="mapSearchResp.total <= 0">
          <el-input id="mapSearch" placeholder="请输入内容" v-model="mapSearchReq.keyword" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="mapSearchFunc"></el-button>
          </el-input>
        </div>
        <div class="search-result" v-else>
          <div class="result-number">
            <el-button icon="el-icon-arrow-left" style="padding: 6px;" @click="backSearch"></el-button>
            <div class="result-tip">搜索 {{ mapSearchReq.keyword }}
              共{{ mapSearchResp.total }}个地点
            </div>
          </div>
          <el-pagination class="page" layout="prev, pager, next" @current-change="handleCurrentChange"
            :total="mapSearchResp.total">
          </el-pagination>
          <div class="infinite-list-wrapper" style="overflow:auto;height: 80%;">
            <div class="search-item" v-for="(item, index) in mapSearchResp.list" @click="handleAddressClick(item)"
              :key="'search-item' + index">
              <div style="font-size: 16px;font-weight: bold;">{{ item.name }}</div>
              <div style="padding-top: 4px;color: #808695;">{{ item.province }}{{ item.city }}{{
                item.address
              }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="update-form" v-if="showDetailsDivState">
        <div class="form-header">
          <span style="font-size: 16px;font-weight: bold;">详情</span>
          <i class="el-icon-close" style="font-weight: bold;font-size: 20px;" @click="closePlaceDetails"></i>
        </div>
        <el-form label-position="left" label-width="80px" style="margin-top: 20px;padding: 0 15px;">
          <el-form-item label="地点名称">
            <el-input v-model="details.name" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="details.address" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="details.phone_name" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="details.phone" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="details.remarks" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="details.create_time" :readonly="true"></el-input>
          </el-form-item>
        </el-form>
        <div
          style="margin-top: 10px;display: flex;flex-direction: row;justify-content: flex-end;padding-right: 20px;padding-bottom: 20px;">
          <el-button size="small" type="danger" plain @click="deletePlace(details)">删除</el-button>
          <el-button size="small" type="primary" @click="showUpdatePlaceDiv">修改</el-button>
        </div>
      </div>

      <div class="update-form" v-if="showFormDivState">
        <div class="form-header">
          <span style="font-size: 18px;font-weight: bold;">地点编辑</span>
          <i class="el-icon-close" style="font-weight: bold;font-size: 20px;" @click="showFormDivState = false;"></i>
        </div>
        <el-form label-position="left" label-width="80px" style="margin-top: 20px;padding: 0 15px;">
          <el-form-item label="地点名称">
            <el-input v-model="placeForm.name"></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="placeForm.address" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="placeForm.phone_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="placeForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="placeForm.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div
          style="margin-top: 10px;display: flex;flex-direction: row;justify-content: flex-end;padding-right: 20px;padding-bottom: 20px;">
          <el-button size="small" @click="showFormDivState = false; showDetailsDivState = true;">取消</el-button>
          <el-button size="small" type="primary" @click="submitPlaceForm">确定</el-button>
        </div>
      </div>


      <el-dialog title="编辑地点" :visible.sync="updateSetting.dialogFormVisible">
        <el-form :model="updateForm">
          <el-form-item label="地点名称" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.address" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.phone_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="客户手机号" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.remarks" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateSetting.dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" size="small" @click="savePlace">保 存</el-button>
        </div>
      </el-dialog>

      <div style="position: fixed;bottom: 20px;left: 540px;">
        <div
          style="display: flex;flex-direction: row;border: 1px solid #f3f4f6;border-radius: 8px;padding: 4px 8px;background-color: #fff;">
          <el-checkbox label="地点名称" size="mini" v-model="showConf.name"
            style="background-color: #fff;margin: 0;padding: 4px 8px;"></el-checkbox>
          <el-checkbox label="悬浮展示" size="mini" v-model="showConf.win"
            style="background-color: #fff;margin: 0;padding: 4px 8px;"></el-checkbox>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import store from 'store'
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Common from '@/components/Common.vue'
import {
  DeletePlace,
  SavePlace,
  GetTeamPlaceList,
  UpdatePlace,
  GetAllTeamPlaceList,
  SearchAddress
} from '../api/place.js'

export default {
  name: 'Index',
  components: { Menu, Common, Header },
  data() {
    return {
      uploadHeaders: {},
      showDetailsDivState: false, // 是否展示详情弹窗
      showFormDivState: false, // 是否展示详情弹窗
      noData: false,
      details: {},
      drawer: false,
      loading: true,
      loadmore: false,
      empty: false,
      detailsIndex: '',
      showConf: {
        name: true,
        win: true,
      },
      markerStyle: {
        text: {
          fontSize: 12,
          fillColor: '#444444',
          padding: [2, 4, 2, 4],
          backgroundColor: '#ffffff',
          borderColor: '#3c9cff',
          borderWidth: 1,
          fold: true
        },
        icon: {
          image: '/static/images/index/sign.png',
          anchor: 'bottom',
          size: [28, 28],
        }
      },
      mapSearchReq: {
        city: '',
        keyword: '',
        page: 1
      },
      mapSearchResp: {
        list: [],
        total: 0
      },
      mapConf: {
        overPlaceId: null,
        center: [
          116.397027, 39.91799
        ]
      },
      keyword: '',
      updateSetting: {
        dialogFormVisible: false,
        formLabelWidth: '120px'
      },
      updateForm: {},
      form: {
        limit: 0,
        page: 1
      },
      total: 0,
      placeList: [],
      placeMarkers: [],
      points: [],
      link: '',
      dingMarker: {},
      placeForm: {},
    }
  },
  computed: {
    noMore() {
      //当起始页数大于总页数时停止加载
      return this.form.page - 1 >= this.total / 100;
    },
    disabled() {
      console.log(this.form.page, this.total)
      return this.loading || this.noMore;
    }
  },
  mounted() {
    let token = store.get('token')
    if (!token) {
      this.$router.push({ name: 'login' })
    }
    this.loadingObj = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.formatPlaceMarkers()
    this.getPlaceList()
    this.uploadHeaders['Access-Token'] = store.get('token')
  },
  methods: {
    initMap(e) {
      this.map = e
      setTimeout(()=>{
        if (this.loadingObj) {
          this.loadingObj.close()
        }
      },10000)
    },
    initLabelsLayer() {
      console.log('ok')
      if (this.loadingObj) {
        this.loadingObj.close()
      }
    },
    handleMouseOver(info) {
      if (this.showConf.win == false) {
        return false;
      }
      // let data = e.data
      // let info = this.placeMarkers[data.index]
      const that = this
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(function () {
        that.mapConf.overPlaceId = info.id
      }, 500)
    },
    handleMouseLeave() {
      this.mapConf.overPlaceId = 0
      clearTimeout(this.hoverTimer)
      this.$forceUpdate()
    },
    handleSelectionChange() {
    },
    // 加载更多
    loadMore() {
      if (this.empty === false) {
        console.log('loadMore')
        this.getPlaceList()
      }
    },
    // 返回搜索框
    backSearch() {
      this.mapSearchResp.total = 0
      this.mapSearchResp.list = []
    },
    // 处理页码变更事件
    handleCurrentChange(e) {
      this.mapSearchReq.page = e
      this.mapSearchFunc()
    },
    // 点击搜索出的地址
    handleAddressClick(item) {
      var that = this
      this.map.remove(this.dingMarker)
      let icon = new AMap.Icon({
        size: new AMap.Size(40, 40), // 图标尺寸
        image: '/static/images/index/ding.png', // Icon的图像
        imageSize: new AMap.Size(40, 40) // 根据所设置的大小拉伸或压缩图片
      })
      var location = item.location.split(',')
      let marker = new AMap.Marker({
        // eslint-disable-next-line no-undef
        position: new AMap.LngLat(location[0], location[1]),
        map: that.map,
        icon: icon,
      })
      this.map.setCenter(new AMap.LngLat(location[0], location[1]))
      this.map.add(marker)
      this.dingMarker = marker
      marker.setMap(this.map) //重置map

      this.placeForm = {
        name: item.name,
        address: item.city + item.address,
        location: item.location,
      }
      this.showFormDivState = true
    },
    submitPlaceForm() {
      SavePlace(this.placeForm).then(res => {
        if (res.code === 200) {
          this.placeForm = {}
          this.showFormDivState = false
          this.$notify({
            type: 'success',
            message: '保存成功'
          })

          this.getPlaceList()
        } else {
          this.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    // 关键词搜索
    mapSearchFunc() {
      var that = this
      SearchAddress(this.mapSearchReq).then(res => {
        if (res.code === 200) {
          this.mapSearchResp = res.data
        }
      })
    },
    showPlaceDetailsMap(info) {
      // let info = this.placeMarkers[data.index]
      this.details = info
      this.map.setCenter(new AMap.LngLat(parseFloat(info.locations.longitude), parseFloat(info.locations.latitude)))
      this.map.setZoom(15)
      this.showDetailsDivState = true
    },
    // 展示地点详情信息
    showPlaceDetails(key) {
      this.detailsIndex = key
      let info = this.placeList[key]
      this.details = info
      this.map.setCenter(new AMap.LngLat(parseFloat(info.locations.longitude), parseFloat(info.locations.latitude)))
      this.map.setZoom(15)
      this.showDetailsDivState = true
    },
    closePlaceDetails() {
      this.showDetailsDivState = false
      this.detailsIndex = ''
      this.details = {}
      this.map.setZoom(14)
    },
    // 显示修改地点的表单
    showUpdatePlaceDiv() {
      this.placeForm = this.details
      this.showDetailsDivState = false
      this.showFormDivState = true
    },
    // 搜索地点库
    searchPlace() {
      this.form.page = 1
      this.getPlaceList()
    },
    // 清除搜索内容
    clearSearch() {
      this.form.name = ''
      this.form.page = 1
      this.list = []
      this.getPlaceList()
    },
    formatPlaceMarkers() {
      let that = this
      GetAllTeamPlaceList().then(res => {
        if (res.code === 200) {
          let list = res.data.list
          if (list.length == 0) {
            this.loadingObj.close()
          }
          this.placeMarkers = list
        } else {
          this.loadingObj.close()
        }
      }).catch(err=>{
        this.loadingObj.close()
      })
    },
    initCenter(info) {
      this.mapConf.center = [parseFloat(info.locations.longitude), parseFloat(info.locations.latitude)]
    },
    getPlaceList() {
      let that = this
      that.loading = true
      GetTeamPlaceList(that.form).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.total = res.data.total
          if (that.form.page <= 1 && res.data.list.length > 0) {
            this.initCenter(res.data.list[0])
          }
          if (that.form.page > 1) {
            for (let i = 0; i < res.data.list.length; i++) {
              that.placeList.push(res.data.list[i])
            }
          } else {
            that.placeList = res.data.list
          }
          if (res.data.list.length > 0) {
            that.form.page++
          }
          if (res.data.total === 0) {
            that.empty = true
          }
        } else {
          that.$notify({
            type: 'error',
            title: '错误',
            message: res.message,
          })
        }
      })
    },
    uploadSuccess(res) {
      if (res.code === 200) {
        if (res.data.link === '') {
          this.$notify({
            type: 'success',
            message: '导入成功'
          })
        } else {
          this.$notify({
            type: 'success',
            message: '部分导入成功,部分失败',
          })
          this.link = res.data.link
        }
      } else {
        this.$notify({
          title: '错误',
          type: 'error',
          message: res.message,
        })
      }
    },
    uploadError(err) {
      this.$notify({
        type: 'error',
        title: '错误',
        message: err
      })
    },
    openUpdateForm(item) {
      this.updateForm = item
      this.updateSetting.dialogFormVisible = true
    },
    savePlace() {
      let that = this
      UpdatePlace(that.updateForm).then(res => {
        if (res.code === 200) {
          that.$notify({
            type: 'success',
            message: '保存成功',
          })
          that.updateSetting.dialogFormVisible = false
          that.refreshPlaceList()
        } else {
          that.$notify({
            type: 'error',
            message: res.message,
            title: '错误',
          })
        }
      })
    },
    refreshPlaceList() {
      this.placeList = []
      this.form.page = 1
      this.getPlaceList()
    },
    deletePlace(info) {
      var that = this
      this.$confirm('是否删除' + info.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DeletePlace({ id: info.id }).then(res => {
          if (res.code === 200) {
            that.$notify({
              type: 'success',
              message: '删除成功'
            })
            that.showDetailsDivState = false
            that.refreshPlaceList()
          } else {
            that.$notify({
              title: '错误',
              type: 'error',
              message: res.message
            })
          }
        })
      }).catch(() => {
        this.$notify({
          title: '提示',
          type: 'info',
          message: '已取消删除'
        })
      })

    },
    phoneNameSearch(queryString, cb) {
      var placeList = this.placeList
      var results = queryString ? placeList.filter(this.phoneNameSearchCreateFilter(queryString)) : placeList
      // 调用 callback 返回建议列表的数据
      console.log(results)
      cb(results)
    },
    phoneNameSelect(item) {
      this.form.phone_name = item.phone_name
    },
    phoneNameSearchCreateFilter(queryString) {
      return (placeList) => {
        return (placeList.phone_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },

    nameSearch(queryString, cb) {
      var placeList = this.placeList
      var results = queryString ? placeList.filter(this.nameSearchCreateFilter(queryString)) : placeList
      // 调用 callback 返回建议列表的数据
      console.log(results)
      cb(results)
    },
    nameSelect(item) {
      this.form.name = item.name
    },
    nameSearchCreateFilter(queryString) {
      return (placeList) => {
        return (placeList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    }
  }
}
</script>

<style>
.map {
  flex: 1;
  height: 100%;
}

.el-card__body {
  padding: 12px;
}

.phone {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  color: #333;
  margin-top: 8px;
}

.update-form {
  display: flex;
  flex-direction: column;
  width: 340px;
  background-color: #fff;
  z-index: 9999;
  position: absolute;
  right: 50px;
  top: 80px;
  border-radius: 8px;
}

.form-header {
  display: flex;
  flex-direction: row;
  height: 40px;
  background-color: #409EFF;
  color: #fff;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.active-card {
  background-color: #ecf5ff;
}

.search-result {
  background-color: #fff;
  height: 80vh;
  width: 360px;
  border-radius: 8px;
  box-shadow: 0 0 4px 0 #999;
}

.result-number {
  width: 100%;
  border-bottom: 1px solid #dcdee2;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}

.result-tip {
  font-weight: bold;
  padding-left: 10px;
  font-size: 16px;
}

.page {
  padding: 12px 0;
  border-bottom: 1px solid #dcdee2;
  /*width: 80%;*/
  margin: 0 auto;
}

.search-item {
  padding: 10px 20px;
  border-bottom: 1px solid #dcdee2;
  width: 90%;
  margin: 0 auto;
}

.route-place-name {
  font-size: 12px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #2979ff;
  white-space: nowrap;
  padding: 2px 4px;
  z-index: 98;
  margin-bottom: 2px;
}

.route-place-sort {
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  border: 2px solid #fff;
  background-color: #2979ff;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue